import React, { useEffect, useState } from "react";
import { matchPath, useLocation, useHistory } from "react-router-dom";
import { models, service } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";

import { reportsApi } from "../../api";

import { useTypedSelector } from "../../store/models/root.interface";
import { ReportItem } from "../../store/models/reports.interface";

import TitleMeta from "../../common/components/TitleMeta";
import Loader from "../../common/components/Loader";
import Layout from "../../components/Layout/Layout";

import "./reports.scss";

interface Params {
  alias?: string;
}

const Reports = () => {

  const history = useHistory();
  const location = useLocation();

  const match = matchPath<Params>(location.pathname, {
    path: "/reports/:alias?"
  });

  const reportAlias = match?.params?.alias;
  const allReports = useTypedSelector(state => state.reports.reports ?? []);
  const reportData = useTypedSelector(state => !!reportAlias && !!state.reports.reportsByAlias
    ? state.reports.reportsByAlias[reportAlias]
    : void 0);

  const [isLoading, setIsLoading] = useState(false);

  const [reportConfig, setReportConfig] = useState<models.IReportEmbedConfiguration>({
    type: "report",
    tokenType: models.TokenType.Embed,
    embedUrl: void 0,
    accessToken: void 0,
    settings: {
      background: models.BackgroundType.Transparent,
    },
  });

  const eventHandlersMap = new Map([
    ["loaded", () => {
    }],
    ["rendered", () => {
      setIsLoading(false);
    }],
    ["error", (event?: service.ICustomEvent<any>) => {
    }]
  ]);

  const fetchParams = async (report: ReportItem) => {
    try {
      const response = await reportsApi.getReportEmbedParams({
        reportId: report.reportId,
      });
      if (!!response.data.embedReport?.length) {
        setReportConfig({
          ...reportConfig,
          embedUrl: response.data.embedReport[0].embedUrl,
          accessToken: response.data.embedToken?.token,
        });
      }
    } catch (err) {
    }
  }

  useEffect(() => {
    if (!reportAlias) {
      const report = allReports[0];
      history.replace(`/reports/${report.alias}`);
    }
  }, [reportAlias]);

  useEffect(() => {
    if (reportData) {
      setIsLoading(true);
      fetchParams(reportData);
    }
  }, [reportData]);

  return (
    <>
      <TitleMeta title={reportData?.name ?? "Report"} />

      <Layout.FullPage>

        <Layout.Header>
          <Layout.Breadcrumb items={["Reports"]} />
          <Layout.Title>{reportData?.name ?? "Report"}</Layout.Title>
        </Layout.Header>

        <div className="flex-grow-1 position-relative">
          <PowerBIEmbed
            embedConfig={reportConfig}
            eventHandlers={eventHandlersMap}
            cssClassName={"report-container"}
          />
          <Loader show={isLoading} background="panel-light" />
        </div>

        <div className="bg-blue text-right text-light py-1 px-2">
          <img
            src="/img/omnicoreinsight-pbda-w-noitalic-nograd.png"
            alt="Simply Insight - Powered by Defaqto Analytics"
            style={{
              maxHeight: "20px",
              maxWidth: "100%",
            }}
          />
        </div>

      </Layout.FullPage>
    </>
  );
};

export default Reports;
